export enum InvitesEvents {
  InviteUsersClick = 'invite_users_click',
  InviteUserEmailSave = 'invite_user_email_save',
  InviteUsersSuccess = 'invite_users_success',
  SendReminderClick = 'send_reminder_click',
  InviteUsersError = 'invite_users_error',
}
